export default "__VITE_ASSET__DdyL8Ydg__"